// extracted by mini-css-extract-plugin
module.exports = {"card":"SummaryCard_card__pcrii","title":"SummaryCard_title___pGVN","row":"SummaryCard_row__Hfsc1","text":"SummaryCard_text__7tmG8","textValues":"SummaryCard_textValues__Oc_yk"};